import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Eye, EyeOff } from "lucide-react";

export default function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const result = await login(email, password);
    if (!result.success) setError(result.error);
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ background: '#F7F5F0' }}>
      <div className="w-full max-w-md">
        <Link to="/" className="block text-center mb-10" data-testid="login-logo-link">
          <span className="text-2xl" style={{ fontFamily: 'Cormorant Garamond, serif', color: '#2D3A31' }}>sober-curious.com</span>
        </Link>
        <div className="earthy-card">
          <h1 className="text-3xl mb-2" style={{ fontFamily: 'Cormorant Garamond, serif', color: '#2D3A31' }}>Welcome back</h1>
          <p className="text-sm mb-8" style={{ color: '#5B665E' }}>Pick up where you left off.</p>
          {error && (
            <div className="mb-4 p-3 rounded-md text-sm" style={{ background: 'rgba(150,69,69,0.08)', color: '#964545', border: '1px solid rgba(150,69,69,0.2)' }} data-testid="login-error">
              {error}
            </div>
          )}
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-medium mb-1.5" style={{ color: '#5B665E' }}>Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="earthy-input" placeholder="you@email.com" required data-testid="login-email-input" />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1.5" style={{ color: '#5B665E' }}>Password</label>
              <div className="relative">
                <input type={showPw ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} className="earthy-input pr-12" placeholder="Your password" required data-testid="login-password-input" />
                <button type="button" onClick={() => setShowPw(!showPw)} className="absolute right-3 top-1/2 -translate-y-1/2 opacity-50 hover:opacity-100 transition-opacity" data-testid="login-toggle-pw">
                  {showPw ? <EyeOff size={18} strokeWidth={1.5} /> : <Eye size={18} strokeWidth={1.5} />}
                </button>
              </div>
            </div>
            <button type="submit" disabled={loading} className="earthy-btn earthy-btn-primary w-full text-base" data-testid="login-submit-btn">
              {loading ? "Logging in..." : "Log In"}
            </button>
          </form>
          <p className="text-center mt-8 text-sm" style={{ color: '#5B665E' }}>
            New here? <Link to="/register" className="font-medium underline" style={{ color: '#4A5D4E' }} data-testid="login-register-link">Join the program</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
